/* Gemlikzade — click-to-play / ambient video. Only one video plays at a time. */
if (!customElements.get('gz-video')) {
  class GzVideo extends HTMLElement {
    connectedCallback() {
      this.type = this.dataset.type;
      this.mode = this.dataset.mode;
      this.playBtn = this.querySelector('.gz-video__play');
      this.toggleBtn = this.querySelector('.gz-video__toggle');

      this.playBtn?.addEventListener('click', () => this.play());
      document.addEventListener('gz-video:play', (event) => {
        if (event.detail !== this) this.pause();
      });

      if (this.mode === 'ambient') this.setupAmbient();
    }

    setupAmbient() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        this.video.removeAttribute('autoplay');
        this.video.pause();
        this.setToggleState(false);
      } else {
        this.classList.add('is-playing');
        this.setToggleState(true);
      }
      this.toggleBtn?.addEventListener('click', () => {
        if (this.video.paused) {
          this.video.play();
          this.setToggleState(true);
        } else {
          this.video.pause();
          this.setToggleState(false);
        }
      });
      // Pause off-screen to save battery.
      if ('IntersectionObserver' in window && !reduce) {
        new IntersectionObserver((entries) => {
          if (!this.video || this.userPaused) return;
          entries[0].isIntersecting ? this.video.play().catch(() => {}) : this.video.pause();
        }, { threshold: 0.1 }).observe(this);
      }
    }

    setToggleState(playing) {
      if (!this.toggleBtn) return;
      this.toggleBtn.classList.toggle('is-paused', !playing);
      this.toggleBtn.setAttribute('aria-label', playing ? this.toggleBtn.dataset.labelPause : this.toggleBtn.dataset.labelPlay);
      this.userPaused = !playing;
    }

    play() {
      document.dispatchEvent(new CustomEvent('gz-video:play', { detail: this }));
      if (this.type === 'shopify') {
        if (!this.video) {
          const template = this.querySelector('template');
          if (!template) return;
          this.appendChild(template.content.firstElementChild.cloneNode(true));
          this.video = this.querySelector('video');
        }
        this.classList.add('is-playing');
        this.video.play().catch(() => {});
        this.video.focus({ preventScroll: true });
      } else if (this.type === 'youtube' || this.type === 'vimeo') {
        if (!this.iframe) {
          const id = encodeURIComponent(this.dataset.id);
          const src = this.type === 'youtube'
            ? `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1&modestbranding=1`
            : `https://player.vimeo.com/video/${id}?autoplay=1&dnt=1`;
          this.iframe = document.createElement('iframe');
          this.iframe.src = src;
          this.iframe.className = 'gz-video__el';
          this.iframe.title = this.playBtn?.getAttribute('aria-label') || 'Video';
          this.iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          this.iframe.allowFullscreen = true;
          this.appendChild(this.iframe);
        }
        this.classList.add('is-playing');
      }
    }

    pause() {
      if (this.mode === 'ambient') return;
      if (this.video && !this.video.paused) this.video.pause();
      if (this.iframe) {
        this.iframe.remove();
        this.iframe = null;
        this.classList.remove('is-playing');
      }
    }
  }
  customElements.define('gz-video', GzVideo);
}
